module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('Form', {
    ref: "form",
    attrs: {
      "model": _vm.model,
      "rules": _vm.rules,
      "label-width": _vm.labelWidth
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitEditForm.apply(null, arguments)
      }
    }
  }, [_vm._t("default", function() {
    return [_vm._v("请在此设计表单")]
  }, {
    "model": _vm.model
  }), _vm._v(" "), _c('FormItem', [(_vm.resetShow) ? _c('Button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.$refs.form.resetFields();
        _vm.$emit('reset')
      }
    }
  }, [_vm._v("重置")]) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitEditForm
    }
  }, [_vm._v(_vm._s(_vm.submitBtnTxt))]), _vm._v(" "), _vm._t("btn")], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f06d1248","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GenericForm.vue
// module id = 666
// module chunks = 114